export const PRODUCT_REPOSITORY_TYPE = {
  UPDATE_PAGE_SIZE: "UPDATE_PAGE_SIZE",
  UPDATE_PAGE_NUMBER: "UPDATE_PAGE_NUMBER",
  UPDATE_CATEGORY: "UPDATE_CATEGORY",
  UPDATE_TAG: "UPDATE_TAG",
  SEARCH: "SEARCH",
};
